import qs from 'qs';

const axios = window.axios;
const $ = window.$;
const _ = window._;

$(() => {
  const $usernameCheckerResult = $('.page_password_checker .username_checker_result');
  const $usernameCheckerResultText = $('.page_password_checker .username_checker_result_text');
  const $postResult = $('.page_password_checker .post_result');

  const usernameDisplayFunc = ({isError, message, loading = false}) => {
    const $usernameCheckerInput = $('.page_password_checker .password_checker_user_name');

    if (loading) {
      $usernameCheckerInput.addClass('loading');
    } else {
      $usernameCheckerInput.removeClass('loading');
      $usernameCheckerResultText.text(message);
      if (isError) {
        $usernameCheckerInput.addClass('error');
        $usernameCheckerInput.removeClass('is-valid');
        $usernameCheckerResult.addClass('badresult-text');
        $postResult.hide();
        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'username_error', 'UserName validation Error', location.href, {nonInteraction: true});
        }
      } else {
        $usernameCheckerInput.addClass('is-valid');
        $usernameCheckerInput.removeClass('error');
        $usernameCheckerResult.removeClass('badresult-text');
        if (typeof ga !== 'undefined') {
          ga('send', 'event', 'username_valid', 'UserName validation OK', location.href, {nonInteraction: true});
        }
      }
    }
    if (document.getElementById('password') != null) {
      if ($('.page_password_checker .password_checker_user_name').hasClass('is-valid')
          && $('.page_password_checker .password_checker_email').hasClass('is-valid')
          && $('.page_password_checker .password_checker_input').hasClass('is-valid')) {
        $('.signup-btn-form-submit').attr('disabled', false);
      }
    } else {
      if ($('.page_password_checker .password_checker_user_name').hasClass('is-valid')
          && $('.page_password_checker .password_checker_email').hasClass('is-valid')) {
        $('.signup-btn-form-submit').attr('disabled', false);
      }
    }
  };

  let userNameCancelRequest = null;
  const usernameValidateFunc = _.debounce(async(username) => {
    // 前回のリクエストをキャンセルする
    if (userNameCancelRequest) {
      userNameCancelRequest();
    }
    try {
      usernameDisplayFunc({loading: true});
      const data = {
        user_name: username
      };
      const options = {
        method: 'POST',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify(data),
        cancelToken: new axios.CancelToken(c => { userNameCancelRequest = c; }),
        url: '/signup/username/validate'
      };
      const {data: {errors} } = await axios(options);

      if (errors) {
        usernameDisplayFunc({isError: true, message: errors[0].message});
      } else {
        usernameDisplayFunc({isError: false, message: ''});
      }
    } catch (e) {
      // 何もしない
    }
  }, 150);

  let keepUserNameValue = '';
  const usernameCheckFunc = () => {
    const username = $('.page_password_checker .password_checker_user_name').val();

    if (!username || !username.length) {
      usernameDisplayFunc({isError: true, message: 'Please enter your username.'});
      return;
    }
    if (keepUserNameValue == username) {
      return;
    }

    usernameValidateFunc(username);
  };

  const setUserNameCheckFunc = ($element) => {
    $element.on('blur', usernameCheckFunc);
  };
  const usernameKeepFunc = () => {
    keepUserNameValue = $('.page_password_checker .password_checker_user_name').val();
  };
  const setUserNameKeepFunc = ($element) => {
    $element.on('focus', usernameKeepFunc);
  };

  const $target = $('.page_password_checker .password_checker_user_name');
  setUserNameCheckFunc($target);
  // 表示時に入力済の場合はチェックする
  if ($target.val() != '') $target.trigger('blur');
  setUserNameKeepFunc($target);
});
